export default __webpack_public_path__ + "static/media/ebook-box-image-03.2fdc7e09.png";